import { useField, useFormikContext } from "formik";

import { FormControl, IconButton, InputAdornment } from "@material-ui/core";
import { KeyboardDatePicker } from "@material-ui/pickers";
import moment from "moment";
import { useCallback } from "react";
import { Clear } from "@material-ui/icons";

export function DateField({ disabled, format, ...props }) {
  const [field, meta] = useField(props.name);
  const { isSubmitting, handleBlur, setFieldValue, values } = useFormikContext();
  const hasError = !!(meta.touched && meta.error);

  const fmt = format || moment.localeData().longDateFormat("L");

  const handleChange = useCallback(
    (date) => {
      // date bisa Date | null | invalid, tergantung input user
      if (!date) {
        setFieldValue(field.name, null, true);
        return;
      }

      const m = moment(date);
      setFieldValue(field.name, m.isValid() ? m.toDate() : null, true);
    },
    [field.name, setFieldValue]
  );

  const handleClear = (e) => {
    // Prevent calendar from opening
    e.stopPropagation();
    e.preventDefault();
    setFieldValue(field.name, null, true);
  };

  return (
    <FormControl margin="normal" fullWidth>
      <KeyboardDatePicker
        name={field.name}
        value={field.value}
        format={fmt}
        allowKeyboardControl
        placeholder={fmt}
        error={hasError}
        helperText={hasError ? meta.error : ""}
        onChange={handleChange}
        onBlur={handleBlur}
        autoOk
        disabled={disabled || isSubmitting}
        InputProps={{
          endAdornment: (
            <>
              {values[field.name] && props.clearable && (
                <InputAdornment position="end">
                  <IconButton onClick={handleClear} size="small" disabled={disabled || isSubmitting} tabIndex={-1}>
                    <Clear fontSize="small" />
                  </IconButton>
                </InputAdornment>
              )}
            </>
          ),
        }}
        {...props}
      />
    </FormControl>
  );
}

export function DateFieldWithIcon({ disabled, ...props }) {
  const [field, meta] = useField(props.name);
  const { isSubmitting, handleBlur, setFieldValue } = useFormikContext();
  const hasError = !!(meta.touched && meta.error);

  const handleChange = useCallback(
    (date) => {
      setFieldValue(field.name, date, true);
    },
    [field.name, setFieldValue]
  );

  return (
    <FormControl margin="normal" fullWidth>
      <KeyboardDatePicker
        name={field.name}
        value={field.value}
        format={moment.localeData().longDateFormat("L")}
        error={hasError}
        helperText={hasError ? meta.error : ""}
        onChange={handleChange}
        onBlur={handleBlur}
        autoOk
        disabled={disabled || isSubmitting}
        {...props}
      />
    </FormControl>
  );
}

export function CustomDateField({ disabled, onChange: customChange, ...props }) {
  const [field, meta] = useField(props.name);
  const { isSubmitting, handleBlur, setFieldValue } = useFormikContext();
  const hasError = !!(meta.touched && meta.error);

  const handleChange = useCallback(
    (date) => {
      setFieldValue(field.name, date, true);

      // Call parent with { name, value } instead of raw date
      if (customChange) {
        customChange({ name: field.name, value: date });
      }
    },
    [field.name, setFieldValue]
  );

  return (
    <FormControl margin="normal" fullWidth>
      <KeyboardDatePicker
        autoOk
        name={field.name}
        value={field.value}
        placeholder="DD/MM/YYYY"
        format={props.format || moment.localeData().longDateFormat("L")}
        error={hasError}
        helperText={hasError ? meta.error : ""}
        onBlur={handleBlur}
        onChange={handleChange}
        disabled={disabled || isSubmitting}
        InputLabelProps={{ shrink: true }}
        {...props}
      />
    </FormControl>
  );
}
